export enum MandateTypeEnum {
  INVESTMENT_CRITERIA = 'InvestmentCriteria',
  LENDER_CRITERIA = 'LendingCriteria',
}
